import {
  blackColor,
  grayColor,
  whiteColor,
  dangerColor,
  successColor,
  blendColors,
} from "assets/jss/material-dashboard-pro-react.js";
import modalStyle from "assets/jss/material-dashboard-pro-react/modalStyle.js";
import customSelectStyle from "assets/jss/material-dashboard-pro-react/customSelectStyle.js";

const plExplorerStyle = (theme) => ({
  ...customSelectStyle(theme),
  right: {
    textAlign: "right",
  },
  center: {
    textAlign: "center",
  },
  topCardIcon: {
    color: grayColor[0],
    fontSize: "16px",
    cursor: "pointer",
    marginLeft: "8px",
    transition: "opacity 150ms",
    "&:hover": {
      color: grayColor[0],
      opacity: "0.5",
    },
    "&:before": {
      fontFamily: "'Font Awesome 5 Free'",
      content: "'\\f0b0'",
      padding: "0 0 0 2px",
      fontWeight: "900",
    },
  },
  topCardButtonContainer: {
    padding: "5px !important",
  },
  topCardButton: {
    margin: "0 !important",
  },
  explorerSpinner: {
    position: "absolute",
    top: "50%",
    right: "20px",
    transform: "translate(0, -50%)",
  },
  drawerSpinner: {
    position: "absolute",
    top: "20px",
    right: "20px",
  },
  plCardWrapper: {
    paddingLeft: "10px !important",
    paddingRight: "0 !important",
  },
  plWrapperOuter: {
    margin: "0 -10px",
    // padding: "0",
  },
  plCard: {
    marginTop: "0",
  },
  plCardBody: {
    padding: "0",
  },
  plNameModalCharCounter: {
    marginTop: "3px",
    color: grayColor[0],
    fontSize: "12px",
  },
  marginBottomSmall: {
    marginBottom: "2px !important",
  },
  plDisplay: {
    opacity: 0,
    transition: "opacity 0.5s",
    "&.show": {
      opacity: 1,
    },
  },
  modalFootnote: {
    marginTop: "8px",
    paddingRight: "6px",
    color: grayColor[0],
    fontSize: "12px",
    lineHeight: "1.5",
    "& > ul": {
      paddingLeft: "18px",
    },
    "& > ul > li": {
      marginTop: "4px",
    },
  },
  drawerHeader: {
    borderBottom: "none",
    padding: "12px 12px 0 12px",
  },
  drawerHeaderValues: {
    paddingTop: "6px",
    fontWeight: "bold",
  },
  drawerContentWrapper: {
    width: "100%",
    maxWidth: "50vw",
    marginTop: "6px",
    padding: "0 2px",
    boxSizing: "border-box",
  },
  drawerSectionTitle: {
    padding: "0 10px",
    fontSize: "14px",
    marginBottom: "0",
  },
  drawerSectionTitleIcon: {
    marginLeft: "5px",
    fontSize: "18px",
    "&.positiveTrend": {
      color: successColor[0],
    },
    "&.negativeTrend": {
      color: dangerColor[0],
    },
  },
  drawerHeaderScope: {
    fontSize: "12px",
    color: grayColor[6],
  },
  drawerTable: {
    width: "100%",
    fontSize: "12px",
    color: grayColor[6],
    whiteSpace: "nowrap",
    overflow: "hidden",
    paddingBottom: "6px",
  },
  drawerGraph: {
    width: "100%",
    padding: "18px 12px 6px 12px",
    backgroundColor: grayColor[6],
  },
  drawerTableContent: {
    textAlign: "center",
    display: "flex",
    "& > div": {
      padding: "0 !important",
    },
    "& > div:first-child": {
      width: "10%",
    },
    "& > div:not(:first-child)": {
      width: "30%",
    },
  },
  drawerTableHeader: {
    color: whiteColor,
    backgroundColor: grayColor[6],
    // backgroundColor: blendColors(grayColor[6], clientColor, 0.7),
  },
  drawerTableData: {
    color: blackColor,
    marginTop: "2px",
  },
  drawerFootnote: {
    marginTop: "12px",
    width: "100%",
    maxWidth: "50vw",
    paddingRight: "6px",
    color: grayColor[0],
    fontSize: "10px",
    lineHeight: "1.25",
    boxSizing: "border-box",
    "& > ul": {
      paddingLeft: "30px",
    },
    "& > ul > li": {
      marginTop: "3px",
    },
  },
  drawerPlAppliedFiltersWrapper: {
    marginTop: "-4px",
    width: "100%",
    paddingRight: "8px",
    marginBottom: "20px",
  },
  plAppliedFiltersWrapper: {
    width: "100%",
    minHeight: "20px",
    paddingTop: "12px",
    paddingBottom: "4px",
    borderRadius: "5px",
    position: "relative",
    margin: "24px 4px 4px 4px",
    border: grayColor[4] + " 1px solid",
  },
  plAppliedFiltersHeader: {
    display: "inline-block",
    position: "absolute",
    top: "-12px",
    left: "5px",
    fontSize: "12px",
    fontWeight: "bold",
    textTransform: "uppercase",
    padding: "0 5px",
    background: whiteColor,
    "&.modal": {
      color: grayColor[0],
    },
    "&.drawer": {
      color: grayColor[6],
    },
  },
  positive: {
    color: successColor[0],
  },
  negative: {
    color: dangerColor[0],
  },
  highlighted: {
    backgroundColor:
      blendColors(grayColor[8], theme.palette.custom.clientColor, 0.9) +
      " !important",
  },
  hidden: {
    display: "none",
  },
  ...modalStyle(theme),
});

export default plExplorerStyle;
